import image1 from './assets/1.jpeg'
import image2 from './assets/2.jpeg'
import image3 from './assets/3.jpeg'
import image4 from './assets/4.jpeg'
import image5 from './assets/5.jpeg'
import image6 from './assets/6.jpeg'
import image7 from './assets/7.jpeg'
import image8 from './assets/8.jpeg'

export default [image1, image2, image3, image4, image5, image6, image7, image8]
